module.exports = __webpack_public_path__ + "static/media/ico_light.6fe4b731.svg";